import { render, staticRenderFns } from "./pluginConfig.vue?vue&type=template&id=21d45505&scoped=true&"
import script from "./pluginConfig.vue?vue&type=script&lang=ts&"
export * from "./pluginConfig.vue?vue&type=script&lang=ts&"
import style0 from "./pluginConfig.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./pluginConfig.vue?vue&type=style&index=1&id=21d45505&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d45505",
  null
  
)

export default component.exports